import { Injectable } from '@angular/core';
import { ApiServiceProvider } from '../api-service/api-service';

@Injectable()
export class RequestServiceProvider {
  constructor(public apiService: ApiServiceProvider) {}

  public createAsk(ask) {
    return this.apiService.post(`/requests`, ask);
  }

  public generateAskFromLink(link) {
    return this.apiService.post(`/requests/scrap`, { link });
  }

  public getById(id) {
    return this.apiService.get(`/requests/${id}`);
  }

  public getRequests(query, page, limit) {
    return this.apiService.get(
      `/requests?query=${query}&page=${page}&limit=${limit}`
    );
  }

  public getPublicRequests() {
    return this.apiService.get('/public/requests');
  }

  public getSpecificPublicRequest(id) {
    return this.apiService.get(`/public/requests/${id}`);
  }

  public getAllCatalogs() {
    return this.apiService.get('/catalogs');
  }

  public getCatalog(id) {
    return this.apiService.get(`/catalogs/${id}`);
  }

  public getRequestsByUserId(id) {
    return this.apiService.get('/requests?userId=' + id);
  }

  public getRequestsFulfilledByUserId(id, page, limit) {
    return this.apiService.get(
      `/requests?userId=${id}&page=${page}&limit=${limit}&status=FULFILLED`
    );
  }

  public getRequestsAskedByUserId(id, page, limit) {
    return this.apiService.get(
      `/requests?userId=${id}&page=${page}&limit=${limit}&status=ASKED`
    );
  }

  public getFulfillmentByUserId(id) {
    return this.apiService.get('/fulfillments/' + id);
  }

  public removeById(id) {
    return this.apiService.delete(`/requests/${id}`);
  }

  public addLikeRequest(id) {
    return this.apiService.post(`/requests/${id}/like`, {});
  }

  public removeLikeRequest(id) {
    return this.apiService.delete(`/requests/${id}/like`);
  }

  public addFriend(id) {
    return this.apiService.post(`/friends/${id}`, {});
  }

  public deleteFriend(id) {
    return this.apiService.delete(`/friends/${id}`);
  }

  public getFriends() {
    return this.apiService.get('/friends');
  }

  public getFriendsRequests() {
    return this.apiService.get('/friends/requests');
  }

  public getTopFriendsRequests() {
    return this.apiService.get('/friends/requests/top');
  }

  public getUserFriends(limit = 3) {
    return this.apiService.get(`/users/suggested?limit=${limit}`);
  }

  public getCannedResponses() {
    return this.apiService.get('/cannedresponses');
  }

  public thanks(thanks) {
    return this.apiService.post('/thanks', thanks);
  }

  public getSuggestedItems() {
    return this.apiService.get('/admin/items');
  }

  public listCategories() {
    return this.apiService.get('/admin/categories');
  }

  public addThanksReply(id, message) {
    return this.apiService.post(`/thanks/${id}/reply`, { message });
  }

  public addCounter(id) {
    return this.apiService.put(`/requests/${id}/added`, {});
  }

  public editRequest(id, ask) {
    return this.apiService.put(`/requests/${id}/`, ask);
  }

  public getSuggested() {
    return this.apiService.get('/requests/suggested');
  }
}



// WEBPACK FOOTER //
// ./src/providers/request-service/request-service.ts